import React from 'react';
import Icon from '@ant-design/icons';

const CheckSquareSVG = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <title>Icon / Check-square</title>
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon-/-Check-square">
        <rect
          id="Rectangle"
          fill="currentColor"
          x="0"
          y="0"
          width="16"
          height="16"
          rx="1"
        />
        <g
          id="Group"
          transform="translate(2.000000, 1.500000)"
          stroke="#FFFFFF"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <g id="check" transform="translate(1.000000, 3.000000)">
            <polyline
              id="Path"
              points="10.2666667 0 3.20833333 6.92307692 0 3.77622378"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const JCheckSquare: React.FC<any> = (props) => {
  return <Icon component={CheckSquareSVG} {...props}  aria-hidden={true}/>;
};
